export const Uncheck = () => (
  <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M13.7885 21.5873H7.7734C2.32974 21.5873 0.00390625 19.2614 0.00390625 13.8178V7.8027C0.00390625 2.35904 2.32974 0.0332031 7.7734 0.0332031H13.7885C19.2321 0.0332031 21.558 2.35904 21.558 7.8027V13.8178C21.558 19.2614 19.2321 21.5873 13.7885 21.5873ZM7.7734 1.53698C3.1518 1.53698 1.50768 3.1811 1.50768 7.8027V13.8178C1.50768 18.4394 3.1518 20.0835 7.7734 20.0835H13.7885C18.4101 20.0835 20.0542 18.4394 20.0542 13.8178V7.8027C20.0542 3.1811 18.4101 1.53698 13.7885 1.53698H7.7734Z"
      fill="#E0E7FF"
    />
  </svg>
);
